import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

// Setup axios as default
axios.defaults.baseURL = 'https://realtimequiz.azurewebsites.net'
Vue.prototype.$http = axios

// Add bootstrap to Vue
Vue.use(BootstrapVue)
// Add bootstrapvue icon component
Vue.use(IconsPlugin)

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate () {
    this.$store.commit('getUserGuid')
  }
}).$mount('#app')
